export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  image: string;
  date: string;
  views: number;
  tags: string[];
  author: string;
  isHot: boolean;
  isNew: boolean;
}

export interface Category {
  name: string;
  slug: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  { name: '明星绯闻', slug: 'mingxing-feiwen', description: '最新明星绯闻八卦，恋情曝光、出轨劈腿一网打尽', icon: 'ri-heart-pulse-line' },
  { name: '内幕揭秘', slug: 'neimu-jiemi', description: '深度揭秘娱乐圈不为人知的内幕与潜规则', icon: 'ri-spy-line' },
  { name: '丑闻曝光', slug: 'chouwen-baoguang', description: '明星丑闻事件追踪，还原事件真相', icon: 'ri-alert-line' },
  { name: '法律纠纷', slug: 'falv-jiufen', description: '明星涉法事件，偷税漏税、合同纠纷全纪录', icon: 'ri-scales-line' },
  { name: '综艺黑幕', slug: 'zongyi-heimu', description: '综艺节目黑幕揭秘，选秀内幕大起底', icon: 'ri-tv-line' },
  { name: '行业潜规则', slug: 'hangye-qian-guize', description: '娱乐圈行业潜规则揭秘，新人必知的生存法则', icon: 'ri-ghost-line' },
];

export const articles: Article[] = [
  {
    id: '1',
    title: '某顶流男星深夜密会神秘女子，酒店共度8小时被拍',
    excerpt: '据知情人士透露，该男星与一名神秘女子在某五星级酒店密会，两人前后进入酒店，直到第二天清晨才分别离开，全程被狗仔队拍下。',
    content: `<p>近日，娱乐圈再爆重磅绯闻。据知情人士向本网爆料，某当红顶流男星在深夜与一名神秘女子在某五星级酒店密会，两人一前一后进入酒店，直到第二天清晨才分别离开，全程被蹲守的狗仔队拍下。</p>
    <p>据目击者描述，当晚约11点左右，该男星戴着口罩和帽子，低调现身酒店地下停车场。约半小时后，一名身材窈窕的神秘女子也出现在同一地点，两人先后进入酒店电梯。</p>
    <p>更令人震惊的是，直到次日早上7点左右，两人才分别从酒店离开。女子先行离开，约20分钟后，男星才戴着口罩匆匆走出酒店，上了一辆等候已久的保姆车。</p>
    <p>该男星此前一直以单身人设示人，粉丝群体庞大。此次被拍到密会神秘女子，引发了网友热议。有粉丝表示"等待官方回应"，也有网友调侃"人设崩塌来得太快"。</p>
    <p>截至发稿前，该男星及其工作室尚未对此事做出任何回应。本网将持续关注此事进展。</p>`,
    category: '明星绯闻',
    categorySlug: 'mingxing-feiwen',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20male%20celebrity%20walking%20at%20night%20wearing%20mask%20near%20luxury%20hotel%20entrance%2C%20paparazzi%20style%20photography%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20urban%20night%20scene%2C%20cinematic%20composition&width=800&height=450&seq=article-1&orientation=landscape',
    date: '2026-08-10',
    views: 128500,
    tags: ['顶流男星', '密会', '酒店', '绯闻', '单身人设'],
    author: '八卦侦探',
    isHot: true,
    isNew: true,
  },
  {
    id: '2',
    title: '知名女星被曝偷税漏税，金额高达数千万，或将面临刑事处罚',
    excerpt: '继多位明星税务风波后，又一位知名女星被税务机关调查。据透露，该女星通过阴阳合同等方式偷逃税款达数千万元。',
    content: `<p>娱乐圈税务风波再起波澜。据可靠消息，某知名一线女星因涉嫌偷税漏税被税务机关立案调查，涉案金额高达数千万元。</p>
    <p>知情人士透露，该女星通过签订"阴阳合同"、虚构业务等方式，将本应缴纳高额税款的个人收入转化为企业收入，从而大幅度降低税负。这种方式在娱乐圈并不鲜见，此前已有多位明星因此被查处。</p>
    <p>据悉，税务机关在对该女星及其关联公司进行税务稽查时发现了多处问题。除了阴阳合同外，还存在虚开发票、虚假申报等问题。目前，税务机关已要求其补缴税款及滞纳金，并可能面临高额罚款。</p>
    <p>法律界人士表示，根据相关法律规定，偷税数额巨大且占应纳税额百分之三十以上的，将面临三年以上七年以下有期徒刑。如果该女星能够主动补缴税款并接受处罚，可能会获得从轻处理。</p>
    <p>该女星近年代言了多个知名品牌，参演的影视作品也颇受关注。此次税务风波无疑将对其演艺事业造成重大影响。</p>`,
    category: '法律纠纷',
    categorySlug: 'falv-jiufen',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20actress%20serious%20expression%20in%20courtroom%20setting%2C%20legal%20documents%20on%20table%2C%20dramatic%20cinematic%20lighting%2C%20professional%20photography%2C%20tense%20atmosphere&width=800&height=450&seq=article-2&orientation=landscape',
    date: '2026-08-09',
    views: 98600,
    tags: ['偷税漏税', '女星', '阴阳合同', '税务稽查', '法律'],
    author: '法制观察员',
    isHot: true,
    isNew: true,
  },
  {
    id: '3',
    title: '选秀节目黑幕曝光：导师内定、选手被潜规则，投票全是假的',
    excerpt: '一位曾参加过某热门选秀节目的选手勇敢站出来，揭露节目组背后的各种黑幕操作，包括导师内定晋级名单、选手被要求配合剧本等。',
    content: `<p>近日，一位曾经参加过某热门选秀节目的选手在社交媒体上发布长文，详细揭露了该选秀节目背后的种种黑幕，引发网友广泛关注和讨论。</p>
    <p>该选手在文中透露，节目录制期间，导演组会提前告知哪些选手能够晋级，哪些选手将被淘汰。所谓的"现场投票"和"网络投票"实际上都是做给观众看的，最终结果早已内定。</p>
    <p>更令人震惊的是，该选手还爆料称，有选手为了获得更多的镜头和晋级机会，不得不配合节目组安排的"剧本"。这些剧本包括制造选手之间的矛盾冲突、安排特定的CP配对、甚至参与某些不正当的交易。</p>
    <p>"观众看到的每一期节目，每一个感人的故事，每一个冲突场面，几乎都是节目组精心设计的，"该选手在文中写道，"真实的选秀根本不是你们想象的那样。"</p>
    <p>此外，该选手还披露了导师选择环节的内幕。据其描述，导师在录制前就已经确定了要选择的选手，节目中的"纠结"和"艰难抉择"都是为了节目效果而表演的。</p>
    <p>这篇文章发布后迅速引发热议，相关话题阅读量短时间内突破5亿。多位业内人士也站出来表示，选秀节目的黑幕早已是行业内公开的秘密。</p>`,
    category: '综艺黑幕',
    categorySlug: 'zongyi-heimu',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20talent%20show%20stage%20with%20spotlights%20and%20empty%20chairs%2C%20dramatic%20dark%20background%2C%20behind%20the%20scenes%20mood%2C%20cinematic%20composition%2C%20mysterious%20atmosphere&width=800&height=450&seq=article-3&orientation=landscape',
    date: '2026-08-08',
    views: 156200,
    tags: ['选秀', '黑幕', '内定', '潜规则', '综艺'],
    author: '圈内知情人',
    isHot: true,
    isNew: false,
  },
  {
    id: '4',
    title: '某流量小花片场耍大牌，迟到4小时还对工作人员爆粗口',
    excerpt: '据剧组工作人员爆料，某当红流量小花在拍摄期间多次迟到早退，对工作人员态度恶劣，甚至当场辱骂化妆师。',
    content: `<p>近日，一位自称是某热播剧剧组工作人员在匿名平台上爆料，称剧组中某位流量小花的行为令人发指，引起了圈内外的广泛关注。</p>
    <p>据该工作人员描述，这位流量小花在拍摄期间多次迟到，最严重的一次竟然让全剧组等了她整整4个小时。当导演委婉提醒时，她不但没有道歉，反而当场发飙，指责导演"不懂欣赏"。</p>
    <p>更过分的是，该流量小花对底层工作人员的态度极其恶劣。在一次化妆过程中，因为不满意妆容效果，她当场对化妆师爆粗口，用极其难听的语言辱骂对方。事后化妆师含泪完成了工作，但因担心丢工作而选择忍气吞声。</p>
    <p>"她在镜头前永远是一副甜美可爱的样子，粉丝都以为她多么善良温柔，"该工作人员写道，"但真实的她就是被粉丝和公司惯坏了的公主病晚期患者。"</p>
    <p>此爆料一出，迅速引发网友热议。不少网友根据描述中的线索，锁定了该流量小花的身份。目前其工作室尚未对此事做出回应。</p>`,
    category: '丑闻曝光',
    categorySlug: 'chouwen-baoguang',
    image: 'https://readdy.ai/api/search-image?query=Empty%20film%20set%20with%20director%20chair%20and%20camera%20equipment%2C%20lonely%20atmosphere%2C%20dramatic%20shadows%2C%20behind%20the%20scenes%20cinematic%20photography%2C%20moody%20lighting&width=800&height=450&seq=article-4&orientation=landscape',
    date: '2026-08-07',
    views: 87500,
    tags: ['耍大牌', '流量小花', '片场', '态度恶劣', '工作人员'],
    author: '剧组线人',
    isHot: false,
    isNew: false,
  },
  {
    id: '5',
    title: '娱乐圈潜规则揭秘：新人想上位有多难？经纪人说出真相',
    excerpt: '一位在娱乐圈从业15年的资深经纪人首次公开揭露行业潜规则，讲述新人从入行到成名的艰辛历程和那些不为人知的黑暗面。',
    content: `<p>在光鲜亮丽的娱乐圈背后，隐藏着多少不为人知的潜规则？近日，一位在娱乐圈摸爬滚打15年的资深经纪人接受了本网的独家专访，首次公开揭露了娱乐圈的种种内幕。</p>
    <p>"想要在娱乐圈出人头地，光有才华是远远不够的，"这位经纪人开门见山地说道，"关系、资源、背景，缺一不可。而对于没有背景的新人来说，他们要面对的是一个充满诱惑和陷阱的世界。"</p>
    <p>据这位经纪人透露，许多经纪公司在签约新人时，会在合同里加入各种不平等条款。新人不仅要被抽取高额佣金，还常常被要求参加各种饭局和应酬。"有些饭局，说白了就是在'推销'新人，"经纪人说，"如果你拒绝参加，那你就没有资源，没有曝光，慢慢就会被雪藏。"</p>
    <p>更令人触目惊心的是，该经纪人还揭露了所谓的"陪睡上位"现象。"这已经不是什么秘密了，"他苦笑道，"有些导演、制片人会直接暗示，如果你想要这个角色，就得付出相应的'代价'。很多新人为了出头，不得不妥协。"</p>
    <p>此外，经纪人还谈到了娱乐圈中普遍存在的"对赌协议"问题。很多明星为了拿到高额片酬，会和投资方签订对赌协议，如果完不成业绩就需要自掏腰包补足差额。这导致很多明星不得不拼命接戏，甚至铤而走险偷税漏税。</p>`,
    category: '行业潜规则',
    categorySlug: 'hangye-qian-guize',
    image: 'https://readdy.ai/api/search-image?query=Dark%20backstage%20corridor%20in%20theater%20with%20single%20spotlight%2C%20mysterious%20and%20dramatic%20atmosphere%2C%20behind%20the%20scenes%20entertainment%20industry%2C%20cinematic%20composition%2C%20contrast%20between%20light%20and%20shadow&width=800&height=450&seq=article-5&orientation=landscape',
    date: '2026-08-06',
    views: 112300,
    tags: ['潜规则', '新人', '经纪人', '内幕', '饭局'],
    author: '深度调查组',
    isHot: true,
    isNew: false,
  },
  {
    id: '6',
    title: '某男团队内霸凌视频流出，成员下跪道歉画面触目惊心',
    excerpt: '一段疑似某当红男团内部霸凌的视频在网上疯传，视频中一名成员被要求下跪向其他成员道歉，画面令人不适。',
    content: `<p>昨天深夜，一段令人震惊的视频在各大社交平台疯狂传播。视频中，疑似某当红男团的一名成员跪在地上，向其他几名成员磕头道歉，而其他成员则站在一旁冷眼旁观，甚至有人发出嘲笑声。</p>
    <p>据知情人士透露，这段视频拍摄于该男团的练习室。事发原因是该成员在排练中出现了失误，导致整体表演效果不佳。作为惩罚，他被要求向所有成员下跪道歉。</p>
    <p>视频一经流出，立刻引发轩然大波。网友们对该男团其他成员的行为表示愤怒和谴责。"这哪里是队友，分明就是霸凌！""太可怕了，这还是我们喜欢的那个团吗？"</p>
    <p>值得注意的是，该男团一直以"团魂满满""兄弟情深"的形象示人，粉丝们也一直引以为傲。此次霸凌视频的曝光，无疑是给粉丝们的一记重锤。</p>
    <p>目前，该男团所属经纪公司已发布声明，称视频内容"断章取义"，并表示将追究泄露视频者的法律责任。但这一回应并未平息舆论，反而引发了更多质疑。</p>
    <p>心理健康专家指出，娱乐圈中长期存在的等级制度和霸凌文化需要引起重视，这不仅会对受害者的心理健康造成严重伤害，也会对整个行业的健康发展产生负面影响。</p>`,
    category: '丑闻曝光',
    categorySlug: 'chouwen-baoguang',
    image: 'https://readdy.ai/api/search-image?query=Empty%20dance%20practice%20room%20with%20mirrors%2C%20dark%20and%20cold%20atmosphere%2C%20lonely%20figure%20shadow%2C%20dramatic%20lighting%2C%20Korean%20style%20entertainment%20practice%20room%2C%20moody%20cinematic%20photography&width=800&height=450&seq=article-6&orientation=landscape',
    date: '2026-08-05',
    views: 201400,
    tags: ['男团', '霸凌', '下跪', '视频流出', '经纪公司'],
    author: '娱乐调查记者',
    isHot: true,
    isNew: false,
  },
  {
    id: '7',
    title: '知名导演被多名女演员指控性骚扰，聊天记录曝光',
    excerpt: '三位女演员联合发声，指控某知名导演在拍摄期间对她们进行性骚扰。曝光的聊天记录令人不寒而栗。',
    content: `<p>娱乐圈再曝性骚扰丑闻。昨日，三位女演员通过社交媒体联合发声，指控某知名导演在合作期间对她们实施了不同程度的性骚扰行为。</p>
    <p>三位女演员分别公开发布了与该导演的聊天记录截图。记录显示，该导演多次在深夜发送带有性暗示的信息，包括"晚上来我房间讨论剧本"、"你的身材很适合这个角色"等露骨言论。其中一位女演员还透露，该导演曾在片场以"指导表演"为由，对她进行了不当的身体接触。</p>
    <p>"我一直不敢说出来，因为我害怕被封杀，"一位女演员在声明中写道，"但当我发现不止我一个人遭受了这样的对待时，我知道不能再沉默了。"</p>
    <p>该导演曾执导多部票房过亿的电影，在业内有着举足轻重的地位。事件曝光后，多家合作方紧急宣布与其终止合作，其正在筹备的新片也被投资方叫停。</p>
    <p>业内人士表示，娱乐圈中的性骚扰问题由来已久，但由于行业特殊的权力结构，受害者往往不敢发声。此次三位女演员的勇敢之举，可能会鼓励更多人站出来说出自己的遭遇。</p>`,
    category: '内幕揭秘',
    categorySlug: 'neimu-jiemi',
    image: 'https://readdy.ai/api/search-image?query=Movie%20director%20chair%20on%20empty%20film%20set%2C%20dramatic%20spotlight%2C%20dark%20and%20serious%20atmosphere%2C%20professional%20cinematic%20photography%2C%20power%20dynamics%20theme&width=800&height=450&seq=article-7&orientation=landscape',
    date: '2026-08-04',
    views: 178900,
    tags: ['性骚扰', '导演', '女演员', '聊天记录', '指控'],
    author: '女性权益报道组',
    isHot: true,
    isNew: false,
  },
  {
    id: '8',
    title: '某综艺节目录制现场发生意外，嘉宾受伤送医，节目组试图掩盖',
    excerpt: '据现场观众爆料，某热门综艺在录制过程中发生安全事故，一名嘉宾从高处摔落受伤，但节目组试图掩盖事实。',
    content: `<p>综艺节目安全问题再次敲响警钟。据参加了某热门综艺录制的现场观众爆料，该节目在最新一期录制过程中发生了一起严重的安全事故。</p>
    <p>据该观众描述，当时正在进行一个需要嘉宾从高处跳下的游戏环节。由于节目组的安全措施不到位，一名嘉宾在落地时失去平衡，头部撞到了地面，当场倒地不起。现场一度陷入混乱。</p>
    <p>"工作人员立刻把嘉宾抬走了，主持人一直在安抚观众情绪，让大家不要拍照录像，"该观众回忆道，"后来节目组还让我们签了一份保密协议，说不签就不能离开。"</p>
    <p>更令人气愤的是，节目组在事发后并未第一时间公布事故情况，反而试图掩盖事实。直到有人在网上曝光，事情才逐渐浮出水面。</p>
    <p>目前，该嘉宾的经纪人已确认其确实在录制中受伤，但目前情况稳定。节目组则发表声明称"高度重视嘉宾安全，将全面检查所有游戏环节的安全措施"。</p>`,
    category: '综艺黑幕',
    categorySlug: 'zongyi-heimu',
    image: 'https://readdy.ai/api/search-image?query=Empty%20TV%20studio%20set%20with%20bright%20lights%20and%20game%20props%2C%20abandoned%20feeling%2C%20dramatic%20contrast%2C%20variety%20show%20behind%20scenes%2C%20cinematic%20photography%2C%20tense%20atmosphere&width=800&height=450&seq=article-8&orientation=landscape',
    date: '2026-08-03',
    views: 94500,
    tags: ['综艺', '安全事故', '嘉宾受伤', '掩盖', '保密协议'],
    author: '安全监督报道组',
    isHot: false,
    isNew: false,
  },
  {
    id: '9',
    title: '两位顶流明星被曝已秘密结婚两年，育有一子',
    excerpt: '某娱乐记者独家爆料，两位当红顶流明星其实早在两年前就已秘密登记结婚，并且已经有了一个一岁多的孩子。',
    content: `<p>娱乐圈最轰动的隐婚消息来了！据知名娱乐记者独家爆料，两位当红顶流明星其实早已在两年前秘密领证结婚，并且育有一个一岁多的孩子。</p>
    <p>该记者在直播中展示了一系列证据，包括两人同进同出某高档小区的照片、带着孩子出游的画面，以及疑似结婚证的复印件。虽然面部被打码处理，但从身形、穿着以及行程时间线上看，指向性非常明确。</p>
    <p>据悉，这两位明星因为担心影响事业发展和粉丝情绪，一直选择隐婚。两人在公共场合从未有过任何亲密互动，甚至在某些活动中刻意保持距离，表现得像陌生人一样。</p>
    <p>消息一出，粉丝群体反应强烈。一部分粉丝表示祝福，认为偶像也有追求个人幸福的权利；另一部分粉丝则感到被欺骗，认为多年来的信任被辜负。</p>
    <p>截至发稿前，两位当事人的工作室均未对此消息做出回应。但据知情人士透露，双方团队正在紧急商讨应对方案。</p>`,
    category: '明星绯闻',
    categorySlug: 'mingxing-feiwen',
    image: 'https://readdy.ai/api/search-image?query=Couple%20silhouettes%20walking%20in%20evening%20city%20street%2C%20romantic%20but%20secretive%20mood%2C%20urban%20night%20scene%2C%20paparazzi%20style%20long%20distance%20shot%2C%20cinematic%20composition%2C%20warm%20but%20mysterious%20atmosphere&width=800&height=450&seq=article-9&orientation=landscape',
    date: '2026-08-02',
    views: 234500,
    tags: ['隐婚', '顶流', '秘密结婚', '生子', '粉丝'],
    author: '独家爆料组',
    isHot: true,
    isNew: false,
  },
  {
    id: '10',
    title: '某经纪公司被曝强迫练习生签"卖身契"，违约金高达上千万',
    excerpt: '调查发现，多家娱乐经纪公司通过不平等合约控制旗下艺人，练习生若想解约需要支付天价违约金。',
    content: `<p>近日，本网记者暗访调查发现，多家娱乐经纪公司在签约练习生和新人时，普遍使用严重不平等的"卖身契"式合同，引发社会广泛关注。</p>
    <p>记者获取的一份经纪合同显示，练习生签约期限长达10-15年，期间所有收入公司抽成高达70%-90%。如果练习生想要提前解约，需要支付高达千万级别的违约金，并赔偿公司所谓的"培训费"和"推广费"。</p>
    <p>"这根本就是现代版的卖身契，"一位曾经签约某大型娱乐公司的前练习生告诉记者，"我们每天训练十几个小时，没有工资，吃饭住宿都要自己掏钱。如果受不了想走，就要赔几百万甚至上千万。"</p>
    <p>更令人震惊的是，合同中的许多条款极其模糊，比如"培训费"和"推广费"的核算标准完全由公司单方面决定。这意味着公司可以随时增加所谓的"成本"，让艺人永远也还不清"债务"。</p>
    <p>法律专家指出，这种严重失衡的合同条款涉嫌违反《劳动合同法》和《民法典》中的公平原则。但由于娱乐行业的特殊性，以及艺人与经纪公司之间复杂的关系，维权之路异常艰难。</p>`,
    category: '行业潜规则',
    categorySlug: 'hangye-qian-guize',
    image: 'https://readdy.ai/api/search-image?query=Stack%20of%20legal%20contracts%20and%20documents%20on%20dark%20wooden%20desk%2C%20dramatic%20side%20lighting%2C%20serious%20legal%20atmosphere%2C%20professional%20photography%2C%20contract%20detail%20closeup&width=800&height=450&seq=article-10&orientation=landscape',
    date: '2026-08-01',
    views: 67200,
    tags: ['经纪公司', '不平等合约', '违约金', '练习生', '卖身契'],
    author: '法制调查组',
    isHot: false,
    isNew: false,
  },
  {
    id: '11',
    title: '某歌手新歌被曝抄袭国外作品，旋律几乎一模一样',
    excerpt: '音乐圈抄袭风波再起，某当红歌手最新发行的单曲被网友扒出与一首三年前发行的国外歌曲旋律高度相似。',
    content: `<p>音乐圈的抄袭风波再次引发关注。近日，某当红歌手刚刚发行的新单曲被网友扒出，其副歌部分旋律与一首三年前发行的国外小众歌曲几乎一模一样。</p>
    <p>有网友制作了两首歌的旋律对比视频，将两首歌的副歌部分叠加播放。结果令人震惊——除了编曲和语言不同外，旋律线条几乎完全重合。这一视频在社交平台上迅速传播，播放量已突破千万。</p>
    <p>音乐制作人分析认为，"在法律上，如果连续8个小节以上完全一致，就可以认定为抄袭。从目前对比情况看，两首歌的副歌部分至少连续16个小节高度相似，抄袭嫌疑非常大。"</p>
    <p>面对质疑，该歌手在社交媒体上发文称"音乐创作难免会有相似之处"，并否认抄袭指控。但这样的回应并未获得网友认可，反而引发了更大的争议。</p>
    <p>目前，原曲的版权方已表示注意到了这一情况，正在评估是否采取法律行动。如果最终被认定为抄袭，该歌手可能面临巨额赔偿和声誉损失。</p>`,
    category: '丑闻曝光',
    categorySlug: 'chouwen-baoguang',
    image: 'https://readdy.ai/api/search-image?query=Music%20studio%20with%20headphones%20and%20sheet%20music%20on%20mixing%20console%2C%20dark%20moody%20lighting%2C%20creative%20atmosphere%2C%20professional%20music%20production%20scene%2C%20cinematic%20composition&width=800&height=450&seq=article-11&orientation=landscape',
    date: '2026-07-31',
    views: 54300,
    tags: ['抄袭', '歌手', '新歌', '版权', '旋律'],
    author: '音乐观察员',
    isHot: false,
    isNew: false,
  },
  {
    id: '12',
    title: '深度起底：娱乐圈"饭圈文化"背后的灰色产业链',
    excerpt: '从刷榜打投到集资应援，饭圈文化已经形成了一条完整的灰色产业链。本网记者历时三个月深入调查。',
    content: `<p>近年来，"饭圈文化"在中国娱乐圈愈演愈烈。从最初单纯的支持偶像，到如今形成了包括刷榜打投、控评反黑、集资应援在内的完整灰色产业链，其规模之大、手段之多令人咋舌。</p>
    <p>本网记者历时三个月，深入调查了这一灰色产业链的运作模式。调查发现，饭圈背后存在着一整套分工明确的组织架构：有专门负责组织集资的"站姐"，有负责数据打投的"数据组"，有负责网络控评的"反黑组"，甚至还有专门负责跟踪艺人的"私生饭"。</p>
    <p>一位曾经在某顶流明星后援会担任管理层的粉丝向记者透露，该后援会每年通过粉丝集资筹集的资金高达数百万元。这些钱一部分用于购买应援物资、组织线下活动，但相当一部分资金的去向并不透明。</p>
    <p>"很多'站姐'靠这个赚得盆满钵满，"该粉丝透露，"她们以各种名义发起集资，但真正花在偶像身上的可能连一半都不到，剩下的都进了自己的腰包。"</p>
    <p>此外，数据造假也是饭圈文化中的一大顽疾。为了给偶像造势，粉丝们会使用各种技术手段刷播放量、刷评论、刷热搜。甚至有专门的"数据公司"提供付费刷量服务，形成了庞大的灰色市场。</p>`,
    category: '内幕揭秘',
    categorySlug: 'neimu-jiemi',
    image: 'https://readdy.ai/api/search-image?query=Crowd%20of%20fans%20holding%20light%20sticks%20at%20concert%2C%20blurred%20motion%2C%20dramatic%20stage%20lighting%2C%20fan%20culture%20atmosphere%2C%20cinematic%20wide%20shot%2C%20energetic%20crowd&width=800&height=450&seq=article-12&orientation=landscape',
    date: '2026-07-30',
    views: 78900,
    tags: ['饭圈', '灰色产业', '集资', '刷榜', '数据造假'],
    author: '深度调查组',
    isHot: false,
    isNew: false,
  },
];

export const siteInfo = {
  name: '明星黑料大全',
  url: 'https://www.mingxingheiliao.com',
  description: '汇聚最新最全明星黑料，深度揭秘娱乐圈内幕、丑闻事件与真相追踪',
  founded: '2020',
  email: 'contact@mingxingheiliao.com',
  phone: '400-888-9999',
  address: '北京市朝阳区星光大道88号传媒大厦15层',
  social: {
    weibo: '明星黑料大全',
    wechat: 'mingxingheiliao',
  },
};

export const faqs = [
  {
    question: '你们的新闻来源是什么？',
    answer: '我们的新闻来源于多个渠道，包括内部线人爆料、娱乐记者调查、公开报道整理以及网友投稿。所有信息在发布前都会经过编辑团队的核实和筛选，确保内容的真实性和可靠性。',
  },
  {
    question: '如何保证新闻的真实性？',
    answer: '我们拥有专业的编辑团队，对每条新闻都进行多源交叉验证。对于无法完全核实的信息，我们会在文章中明确标注"据传"或"疑似"等字样，绝不混淆视听。',
  },
  {
    question: '被报道的明星可以要求删除文章吗？',
    answer: '我们坚持新闻真实性原则。如果报道内容确实存在失实之处，我们会在核实后及时更正或撤稿。但如果报道内容属实，我们不会因为外界压力而删除真实报道。',
  },
  {
    question: '如何向你们提供新闻线索？',
    answer: '您可以通过我们的投稿邮箱或在线表单提交新闻线索。我们承诺对所有提供线索的读者信息严格保密，并根据线索价值给予相应报酬。',
  },
  {
    question: '你们会跟踪报道后续进展吗？',
    answer: '当然！对于重大新闻事件，我们会持续跟踪报道，及时更新事件的最新进展。您可以在文章页面底部找到相关事件的跟进报道链接。',
  },
];